import { useSystem } from "../api/queries";
import { Card, ErrorNote, Loading, Meter, PageHeader } from "../components/ui";
import type { GpuStatus } from "../api/types";

function GpuRow({ g }: { g: GpuStatus }) {
  const memPct = g.mem_total_mib ? (g.mem_used_mib / g.mem_total_mib) * 100 : 0;
  const tempColor = g.temp_c >= 80 ? "var(--bad)" : g.temp_c >= 65 ? "var(--warn)" : "var(--good)";
  return (
    <div className="gpu-row">
      <div className="gpu-row-top">
        <span className="mono">GPU {g.index}</span>
        <span className="dim">{g.name}</span>
        <span className="mono" style={{ color: tempColor }}>{g.temp_c}°C</span>
      </div>
      <div className="gpu-row-meters">
        <label className="dim">util {g.util_pct}%</label>
        <Meter pct={g.util_pct} />
        <label className="dim">
          mem {(g.mem_used_mib / 1024).toFixed(1)}/{(g.mem_total_mib / 1024).toFixed(0)}G
        </label>
        <Meter pct={memPct} color="var(--accent-dim)" />
      </div>
    </div>
  );
}

export function System() {
  const { data, isLoading, error } = useSystem();
  return (
    <div className="page">
      <PageHeader title="System" sub={data ? `orchestrator v${data.version}` : undefined} />
      {isLoading && <Loading what="fleet" />}
      {error && <ErrorNote error={error} />}
      {data && (
        <>
          <Card title="GPU fleet" right={<span className="dim">{data.gpu_count} visible</span>}>
            {data.gpus.length === 0 ? (
              <p className="dim">No GPUs visible (CPU-only or no driver).</p>
            ) : (
              <div className="gpu-list">
                {data.gpus.map((g) => <GpuRow key={g.index} g={g} />)}
              </div>
            )}
          </Card>
          <Card title="Disk">
            <div className="kv">
              <span className="dim">free</span>
              <span className="mono">{data.disk.free_gb} GB</span>
              <span className="dim">used</span>
              <span className="mono">{data.disk.used_gb} GB</span>
              <span className="dim">total</span>
              <span className="mono">{data.disk.total_gb} GB</span>
            </div>
            <Meter pct={data.disk.total_gb ? (data.disk.used_gb / data.disk.total_gb) * 100 : 0} />
          </Card>
          <Card title="Auth">
            <p className="dim">
              {data.auth_required ? "Token-gated." : "Open (no token configured)."}
            </p>
          </Card>
        </>
      )}
    </div>
  );
}
